import moment from "moment";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
const fetcher = (url) => API.get(url).then((res) => res.data.data);
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);
const RequisitionRepProductDate = () => {
  const [openElement, setOpenElement] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  const [typeError, setTypeError] = useState("");
  // get Enties All Product Data
  const {
    data: requisitionProductDateWise,
    error,
    mutate,
  } = useSWR(
    selectedProduct.value && fromDate && toDate
      ? `store/reports/requisitions?queryFor=product&fdate=${fromDate}&tdate=${toDate}&proid=${selectedProduct.value}`
      : null,
    fetcher
  );
  //console.log(requisitionProductDateWise);
  // get product Option
  const { data: productOption, error: error3 } = useSWR(
    `store/products/storeProducts?page=${0}&limit=${100000}`,
    fetcher1
  );

  // handle product select;
  const handleProduct = (product) => {
    setSelectedProduct(product);
  };

  // set Product select list
  let productCategory = [];
  if (productOption && productOption.length > 0) {
    productCategory = productOption.map((data) => {
      let optionsItem = {};
      optionsItem.value = data.PROID;
      optionsItem.label = `${data.PRONAME} - ${data.PRONAMETWO}`;
      return optionsItem;
    });
  }

  // toggle seach button
  const handleToggle = () => {
    if (!fromDate || !toDate || !selectedProduct.value) {
      setTypeError("field Required");
      setOpenElement(false);
      setPrintButton(false);
    } else {
      setOpenElement(true);
      setPrintButton(true);
      setTypeError("");
    }
  };

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>
      <style type="text/css">{"label{font-size:1rem !important}"}</style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">
              Requisition Reports By Product & Date Wise
            </h3>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-color px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              <div className="add_category text-center">
                <div className="row mx-3">
                  <div className="col-12 col-md-3 col-lg-6">
                    <label htmlFor="product_name">
                      Product Name <span className="color-red">*</span>
                    </label>
                    <Select
                      onChange={handleProduct}
                      style={{ borderRadius: "10px" }}
                      className="text-start fs-6"
                      options={productCategory}
                    />
                    <p className="text-start text-danger">
                      {selectedProduct.value ? "" : typeError}
                    </p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <label
                      htmlFor="text-start From_Date"
                      className="text-start"
                    >
                      From Date
                    </label>
                    <input
                      onChange={(e) => {
                        setFromDate(e.target.value);
                      }}
                      type="date"
                      name="From_Date"
                      className="p-2 input-field"
                    />
                    <p className="text-start text-danger">
                      {fromDate ? "" : typeError}
                    </p>
                  </div>
                  <div className="col-12 col-md-3 col-lg-3">
                    <label htmlFor="To_Date">To Date</label>
                    <input
                      onChange={(e) => {
                        setToDate(e.target.value);
                      }}
                      type="date"
                      name="To_Date"
                      className="p-2 input-field"
                    />
                    <p className="text-start text-danger">
                      {toDate ? "" : typeError}
                    </p>
                  </div>
                </div>
                <br />
                <button
                  onClick={handleToggle}
                  type="button"
                  className="mt-3 px-5 btn btn-color_store"
                >
                  <i className="fa fa-search"></i>
                  <span> Search</span>
                </button>
              </div>

              {/* Search Result */}
              {requisitionProductDateWise ? (
                <div
                  ref={componentRef}
                  className={
                    openElement
                      ? "category show my-4 table-container p-2"
                      : "category my-4 table-container p-2"
                  }
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>

                      <h3>দ্রব্য চাহিদার পরিমাণ</h3>
                      <h5>
                        ( {selectedProduct.label} <br /> From{" "}
                        {moment(new Date(fromDate)).format("DD-MM-YYYY")} To{" "}
                        {moment(new Date(toDate)).format("DD-MM-YYYY")} )
                      </h5>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr>
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Date
                          </th>

                          <th className=" col-design1" colSpan="1">
                            Requested
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Approved
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Remarks
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Person
                          </th>
                        </tr>
                      </thead>
                      {requisitionProductDateWise.products && (
                        <tbody>
                          {requisitionProductDateWise.products.map(
                            (product, index) => (
                              <tr key={index}>
                                <th className=" col-design1" colSpan="1">
                                  {index + 1}
                                </th>
                                <td className=" col-design1" colSpan="1">
                                  {moment(new Date(product.PRODATE)).format(
                                    "DD-MM-YYYY"
                                  )}
                                </td>
                                {/* <td colSpan="1" >
                              {product.PRONAMETWO} <br /> ({product.PRONAME})
                            </td> */}
                                <td
                                  colSpan="1"
                                  className="text-center col-design1"
                                >
                                  {product.PROREQUQTY}
                                </td>
                                <td
                                  colSpan="1"
                                  className="text-center col-design1"
                                >
                                  {product.APROQTY}
                                </td>
                                <td
                                  className="text-start col-design1"
                                  colSpan="1"
                                >
                                  {product.PREMARKS}
                                </td>
                                <td
                                  className="text-start col-design1"
                                  colSpan="1"
                                >
                                  {product.NAME_ENGLISH} <br />
                                  {product.DESIGNATION} <br />
                                  {product.DEPARTEMENT}
                                </td>
                              </tr>
                            )
                          )}

                          <tr>
                            <td className=" col-design1" colSpan="1"></td>
                            <td colSpan="2" className="fw-bold col-design1">
                              Total Requisition
                            </td>
                            <td
                              className="fw-bold text-center col-design1"
                              colSpan="1"
                            >
                              {requisitionProductDateWise.TotalApprove}
                            </td>
                            <td className=" col-design1" colSpan="1"></td>
                            <td className=" col-design1" colSpan="1"></td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default RequisitionRepProductDate;
